import React from 'react';
import Box from '@firsttable/web-components/atoms/Box';
import Link from '@firsttable/web-components/atoms/Link';
import {
  formatTikTokUrl,
  formatFacebookUrl,
  formatInstagramUrl,
  formatUrl,
} from '@firsttable/functions/src/functions';
import IconInstagram from '@firsttable/web-components/atoms/Icon/IconInstagram';
import IconFacebook from '@firsttable/web-components/atoms/Icon/IconFacebook';
import IconWebsite from '@firsttable/web-components/atoms/Icon/IconWebsite';
import IconTikTok from '@firsttable/web-components/atoms/Icon/IconTikTok';
import { TrackProvider } from '@/components/analytics/context/AnalyticsContext';
import withMouseDown from '@/components/analytics/hocs/withMouseDown';
import { cn } from '@discover-lib/utils';

const TikTokLink = withMouseDown(Link, 'tiktok', 'navigation', 'tiktok icon');
const InstagramLink = withMouseDown(Link, 'instagram', 'navigation', 'instagram icon');
const FacebookLink = withMouseDown(Link, 'facebook', 'navigation', 'facebook icon');
const WebsiteLink = withMouseDown(Link, 'website', 'navigation', 'website icon');

type SocialIconProps = {
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
};

const SocialIcon = ({ Icon }: SocialIconProps) => (
  <Icon role="button" className="transition duration-200 hover:opacity-75" />
);

type RestaurantShareProps = {
  className?: string;
  tiktok?: string;
  instagram?: string;
  facebook?: string;
  website?: string;
};

export default function RestaurantShare({
  className,
  tiktok,
  instagram,
  facebook,
  website,
}: RestaurantShareProps) {
  return (
    <div className={cn('flex sm:gap-2', className)}>
      {!!tiktok && (
        <div className="scale-[80%] sm:scale-100">
          <TrackProvider link_name="tiktok">
            <TikTokLink href={formatTikTokUrl(tiktok)}>
              <SocialIcon Icon={IconTikTok} />
            </TikTokLink>
          </TrackProvider>
        </div>
      )}
      {!!instagram && (
        <div className="scale-[80%] sm:scale-100">
          <TrackProvider link_name="instagram">
            <InstagramLink href={formatInstagramUrl(instagram)}>
              <SocialIcon Icon={IconInstagram} />
            </InstagramLink>
          </TrackProvider>
        </div>
      )}
      {!!facebook && (
        <div className="scale-[80%] sm:scale-100">
          <TrackProvider link_name="facebook">
            <FacebookLink href={formatFacebookUrl(facebook)}>
              <SocialIcon Icon={IconFacebook} />
            </FacebookLink>
          </TrackProvider>
        </div>
      )}
      {!!website && (
        <div className="scale-[80%] sm:scale-100">
          <TrackProvider link_name="website">
            <WebsiteLink href={formatUrl(website)}>
              <SocialIcon Icon={IconWebsite} />
            </WebsiteLink>
          </TrackProvider>
        </div>
      )}
    </div>
  );
}
